<template>
    <div class="echart12">
        <div ref="echart12" style="width:100%; height:200px;"></div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
        data12:{
            type: Object
        }
    },
    mounted() {
      let chart12 = this.$echarts.init(this.$refs.echart12)
      let xdata = this.data12.xdata
      let yData = this.data12.yData,
      barData = this.data12.barData

      let option = {
        color: ['#5BFCF4','#EB3B5A'],
        tooltip: {
            trigger: 'axis',
            axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
            }
        },
        grid: {
            left: '3%',
            right: '4%',
            bottom: '20%',
            containLabel: true
        },
        xAxis: [
            {
                type: 'category',
                splitLine: {
                    show: false
                },
                axisLine: {
                    show: false
                },
                axisLabel: {
                    color: '#ffffff',
                    textStyle: {
                        fontSize: 12
                    }
                },
                data: xdata
            }
        ],
        yAxis: [
            {
                type: 'value',
                name: '总价(元)',
                nameTextStyle: {
                    color: "#fff",
                    fontSize: 14,
                },
                splitLine: {
                    show: false
                },
                axisLine: {
                    show: false
                },
                axisLabel: {
                    color: '#ffffff',
                    formatter: '{value}'
                }
            }
        ],
        series: [
            {
                name: '收入',
                type: 'bar',
                data: yData
            },
            {
                name: '支出',
                type: 'bar',
                data: barData
            }
        ]
      }
  
      chart12.setOption(option, true)
    }
  }
  </script>
  
<style>
.echart12 {
    font-size: 10px;
    font-weight: 700;
    width: 100%;
    margin-left: -20px;
}
</style>
  